import environment from "../environment";
import { GET, GETWithParams } from "./http.service";

const _endpoint = environment.COACH_ENDPOINT;

export const getAllCoaches = async () => {
  const response = await GETWithParams(
    `Tutor`,
    { orderBy: "Sort" },
    false
  );
  return response;
};

export const getCoachInfo = async (id) => {
  const response = await GETWithParams(
    `Tutor`,
    { searchBy: "id", searchText: id },
    false
  );
  return response;
};

export const getCoachCourses = async (name) => {
  const response = await GET(`${_endpoint}/${name}/courses`, false);
  return response;
};
